<template>
  <div>
    <div ref="graphContainer" class="w-full h-full p-3">
      <Chart
        type="radar"
        :data="chartData"
        :options="chartOptions"
        class="w-full h-full flex align-items-center justify-content-center"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import Chart from "primevue/chart";

// #region Props, Emits
const props = defineProps({
  chart: {
    type: Object,
    required: true,
  },
});
// #endregion

// #region Params, Ref, Reactives, Computed
const graphContainer = ref(null);
const chartData = ref();
const chartOptions = ref();
// #endregion

// #region Functions
onMounted(() => {
  loadGraph();

  // Listen window resize
  window.addEventListener("resize", () => {
    setTimeout(() => {
      loadGraph();
    }, 100);
  });
});

function loadGraph() {
  chartData.value = setChartData();
  chartOptions.value = setChartOptions();
}

function setChartData() {
  const documentStyle = getComputedStyle(document.documentElement);
  const textColor = documentStyle.getPropertyValue("--text-color");

  const radarProperties = props.chart.propiedades.radar;

  const datasets = [];

  radarProperties.datasets.forEach((dataset) => {
    datasets.push({
      label: dataset.label,
      borderColor: dataset.color,
      pointBackgroundColor: dataset.color,
      pointBorderColor: dataset.color,
      pointHoverBackgroundColor: textColor,
      pointHoverBorderColor: dataset.color,
      data: dataset.data,
    });
  });

  return {
    labels: radarProperties.params,
    datasets,
  };
}

function setChartOptions() {
  const documentStyle = getComputedStyle(document.documentElement);
  const textColor = documentStyle.getPropertyValue("--text-color");
  const textColorSecondary = documentStyle.getPropertyValue(
    "--text-color-secondary"
  );

  return {
    plugins: {
      legend: {
        labels: {
          color: textColor,
        },
      },
    },
    scales: {
      r: {
        grid: {
          color: textColorSecondary,
        },
      },
    },
  };
}
// #endregion

// #region Effects, Hooks
// #endregion

// #region Provide, Expose
// #endregion
</script>
